import React, { useState } from 'react';
import Editor from '@monaco-editor/react';

const LINE_HEIGHT = 19;
const CHROME_HEIGHT = 16;     // top/bottom padding Monaco reserves regardless of content
const isNode = (v) => v !== null && typeof v === 'object';

// A value as JSON in Monaco, the VS Code editor, the way the queue site shows it: line numbers, fold arrows, syntax colours, search (Ctrl+F in the
// editor) and a Copy JSON button. @monaco-editor/react loads Monaco from its CDN, so nothing is bundled. Read only. Text that is not JSON (a job's
// log, say) is shown as it is.
export default function JsonView({ value, label = 'JSON', maxHeight = 420 }) {
  const [copied, setCopied] = useState(false);
  const node = isNode(value);
  const text = node ? JSON.stringify(value, null, 2) : String(value === undefined || value === null ? '' : value);
  const height = Math.min(maxHeight, Math.max(60, text.split('\n').length * LINE_HEIGHT + CHROME_HEIGHT));
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (ex) {
      setCopied(false);
    }
  };
  return (
    <div className="v2-json" role="region" aria-label={label}>
      <button type="button" className="v2-btn v2-json-copy" onClick={copy}>{copied ? 'Copied' : 'Copy JSON'}</button>
      {node ? (
        <Editor
          height={height}
          language="json"
          theme="vs-dark"
          value={text}
          options={{
            ariaLabel: label,
            readOnly: true,
            domReadOnly: true,
            minimap: { enabled: false },
            folding: true,
            showFoldingControls: 'always',     // the default shows the arrows only on hover, which is easy to miss
            lineNumbers: 'on',
            scrollBeyondLastLine: false,
            fontSize: 12.5,
            renderLineHighlight: 'none',
            wordWrap: 'on',
            automaticLayout: true,
            overviewRulerLanes: 0,
            hideCursorInOverviewRuler: true,
            scrollbar: { alwaysConsumeMouseWheel: false },
          }}
        />
      ) : <pre className="v2-json-text">{text}</pre>}
    </div>
  );
}
